import React, { memo } from 'react'

interface IListHeader {
  pickup?: string
  delivery?: string
  date?: string
}

export const ListHeader = memo<IListHeader>(({ date, delivery, pickup }) => (
  <div>
    <div className='mb2'>
      <strong>Matching Carriers</strong>
    </div>
    {pickup && delivery && (
      <div className='mb1'>
        {pickup} – {delivery} &middot; {date}
      </div>
    )}
  </div>
))
